var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4583 13.875V2.54167C12.4583 1.75926 11.8241 1.125 11.0417 1.125H3.95833C3.17593 1.125 2.54167 1.75926 2.54167 2.54167V13.875M12.4583 13.875L13.875 13.875M12.4583 13.875H8.91667M2.54167 13.875L1.125 13.875M2.54167 13.875H6.08333M5.375 3.95832H6.08333M5.375 6.79165H6.08333M8.91667 3.95832H9.625M8.91667 6.79165H9.625M6.08333 13.875V10.3333C6.08333 9.94212 6.40046 9.62498 6.79167 9.62498H8.20833C8.59953 9.62498 8.91667 9.94212 8.91667 10.3333V13.875M6.08333 13.875H8.91667",
    stroke: "#EAA827",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon1);
export default __webpack_public_path__ + "static/media/info-icon-1.535d34767cfc7a9eca42fc41a021898f.svg";
export { ForwardRef as ReactComponent };